<template>
  <v-row no-gutters v-if="student">
    <v-col cols="12" class="d-md-none text-right">
      <v-btn
        color="primary"
        class="mr-2"
        @click="save"
        v-if="['education_manager', 'super_admin'].includes(role.type)"
        medium
        depressed
        >Lưu</v-btn
      >
      <v-btn :to="'/students'" depressed medium @click="cancel">Hủy</v-btn>
    </v-col>

    <v-col
      cols="12"
      md="4"
      :class="{ 'text-center': $vuetify.breakpoint.smAndDown }"
    >
      <user-avatar-picker :student="student" type="student" />
    </v-col>

    <v-col cols="12" md="8">
      <v-col cols="12">
        <div class="d-flex justify-space-between">
          <h3 class="mb-2">Thông tin cá nhân</h3>
          <div class="d-none d-md-block" v-if="['education_manager', 'super_admin'].includes(role.type)">
            <v-btn depressed medium color="primary" class="mr-2" @click="save"
              >Lưu</v-btn
            >
            <v-btn :to="'/students'" depressed medium @click="cancel"
              >Hủy</v-btn
            >
          </div>
        </div>
        <h4 class="mb-2">Thông tin cơ bản</h4>
        <student-info-form
          ref="studentInfoForm"
          :student="student"
          :readonly="!['education_manager', 'super_admin'].includes(role.type)"
        />
        <h4 class="mb-2">Địa chỉ</h4>
        <user-address-form ref="studentAddressForm" :address="student.data" />
      </v-col>

      <v-col cols="12">
        <h3 class="mb-2">Thông tin khóa học</h3>
        <student-department-form
          ref="studentDepartmentForm"
          :student="student"
          :readonly="!['education_manager', 'super_admin'].includes(role.type)"
        />
        <!-- <h4 class="my-4">Lớp học</h4>
        <student-class-form ref="studentClassForm" :student="student" /> -->
      </v-col>

      <v-col cols="12">
        <h3 class="mb-2">Học tập & làm việc</h3>
        <h4 class="mb-2">Trường cấp 3</h4>
        <student-high-school-form
          ref="studentHighSchoolForm"
          :student="student"
          :readonly="!['education_manager', 'super_admin'].includes(role.type)"
        />
        <h4>Trường Đại học</h4>
        <student-university-form
          ref="studentUniversityForm"
          :data="student.data"
          :readonly="!['education_manager', 'super_admin'].includes(role.type)"
        />
        <h4>Công ty</h4>
        <student-company-form
          :readonly="!['education_manager', 'super_admin'].includes(role.type)"
          ref="studentCompanyForm"
          :work="student.data"
        />
      </v-col>

      <v-col cols="12">
        <h3 class="mb-2">Thông tin liên hệ</h3>
        <student-contact-form
          :readonly="!['education_manager', 'super_admin'].includes(role.type)"
          ref="studentContactForm"
          :student="student"
        />
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import StudentInfoForm from '@/components/basic/form/StudentInfoForm'
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import StudentHighSchoolForm from '@/components/basic/form/UserHighSchoolForm'
import StudentUniversityForm from '@/components/basic/form/UserUniversityForm'
import StudentCompanyForm from '@/components/basic/form/UserCompanyForm'
import UserAddressForm from '@/components/basic/form/UserAddressForm'
import StudentContactForm from '@/components/basic/form/StudentContactForm'
import StudentDepartmentForm from '@/components/basic/form/StudentDepartmentForm.vue'

export default {
  components: {
    StudentInfoForm,
    UserAddressForm,
    UserAvatarPicker,
    StudentCompanyForm,
    StudentHighSchoolForm,
    StudentUniversityForm,
    StudentDepartmentForm,
    StudentContactForm,
  },
  props: {
    student: Object,
  },
  data() {
    return {
      tab: null,
    }
  },
  computed: {
    ...mapGetters('student', ['logs']),
    ...mapState('auth', ['user', 'role']),
  },
  created() {},
  methods: {
    ...mapActions('student', ['updateStudent', 'fetchLogs']),
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    save() {
      const studentInfo = this.$refs.studentInfoForm.getData()
      const studentDepartment = this.$refs.studentDepartmentForm.getData()
      const studentAddress = this.$refs.studentAddressForm.getData()
      const studentHighSchool = this.$refs.studentHighSchoolForm.getData()
      const studentUniversity = this.$refs.studentUniversityForm.getData()
      const studentCompany = this.$refs.studentCompanyForm.getData()
      const studentContactForm = this.$refs.studentContactForm.getData()

      this.updateStudent({
        id: this.student.id,
        ...studentInfo,
        address: studentAddress.frequentlyAddress,
        ...studentDepartment,
        data: {
          ...this.student.data,
          facebook: studentInfo.facebook,
          ...studentAddress,
          ...studentHighSchool,
          ...studentUniversity,
          ...studentCompany,
          ...studentContactForm,
        },
      })
    },
    cancel() {
      this.state = false
    },
  },
}
</script>

<style scoped>
.border {
  border: solod 1px lightgray;
  border-radius: 4px;
}
</style>
